import { render, staticRenderFns } from "./PromptProductsList.vue?vue&type=template&id=1d858dbe&scoped=true&"
import script from "./PromptProductsList.vue?vue&type=script&lang=js&"
export * from "./PromptProductsList.vue?vue&type=script&lang=js&"
import style0 from "./PromptProductsList.vue?vue&type=style&index=0&id=1d858dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d858dbe",
  null
  
)

export default component.exports